import { render, staticRenderFns } from "./search-page.vue?vue&type=template&id=5c22f6da&scoped=true&"
import script from "./search-page.vue?vue&type=script&lang=js&"
export * from "./search-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22f6da",
  null
  
)

export default component.exports